import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { QuoteForm } from '../components/QuoteForm';
import { TipsSection } from '../components/TipsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { DifferentialsSection } from '../components/DifferentialsSection';
import { ContactSection } from '../components/ContactSection';

export const Home = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <ServicesSection />
        <QuoteForm />
        <TipsSection />
        <TestimonialsSection />
        <DifferentialsSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};
